module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Rose Gold + Black Leather Closed.984d72dd.png";